
import { createLogger} from 'redux-logger';

export const logger = createLogger({
    predicate: (getState, action) => action.type !== 'AUTH_REMOVE_TOKEN',
});